// Global function to toggle no-scroll class on body
window.toggleNoScroll = function (enable = true) {
  const root = document.documentElement;
  const scrollbarWidth = window.innerWidth - root.clientWidth;

  root.classList.toggle("no-scroll", enable);
  document.body.classList.toggle("no-scroll", enable);

  if (enable) {
    // if (isAppleOrTablet()) {
    //   root.style.position = "fixed";
    // }
    root.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  } else {
    // if (isAppleOrTablet()) {
    //   root.style.position = "relative";
    // }
    setTimeout(() => {
      root.style.setProperty("--scrollbar-width", "0px");
    }, 10);
  }
};

// Function to detect iOS, and tablets
function isAppleOrTablet() {
  const userAgent = navigator.userAgent.toLowerCase();
  const platform = navigator.platform.toLowerCase();
  return (
    /ipad|iphone|ipod/.test(userAgent) ||
    (/android/.test(userAgent) && !/mobile/.test(userAgent))
  );
}
